var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Grid from "syf-component-library/ui/patterns/Grid";
import { AccountDetail } from "../../../atoms/AccountDetail";
import { AutopayButton } from "../../../atoms/AutopayButton";
import AccountImage from "../../../atoms/AccountImage/AccountImage";
import i18n from "../../../../strings/i18n";
import { CustomGridVertical } from "../CardBody.style";
import shouldShowPreDeliveryMessage from "../../../../helpers/shouldShowPreDeliveryMessage";
export var nextAmountTooltip = function (isIntroRateLoan, isPN4, isInstallmentLoanMonthly, isSetpay) {
    if (isPN4)
        return i18n({
            labels: "nextAmountPN4Tooltip",
        });
    if (isInstallmentLoanMonthly || isSetpay || isIntroRateLoan) {
        return i18n({
            labels: "nextAmountMonthlyTooltip",
        });
    }
    return undefined;
};
var tooltipTextSectionOne = function (isInstallmentLoanMonthly, promoEndDate) {
    var currentDate = new Date().toISOString().split("T")[0];
    var isPromoFinished = !!promoEndDate && currentDate > promoEndDate;
    var labelForPromo = !isPromoFinished
        ? "beforePromoExpirationTooltip"
        : "afterPromoExpirationTooltip";
    var toDisplayPromoEndDate = promoEndDate === null || promoEndDate === void 0 ? void 0 : promoEndDate.split("-");
    return !!promoEndDate && isInstallmentLoanMonthly
        ? i18n({
            labels: labelForPromo,
        }, {
            date: toDisplayPromoEndDate &&
                "".concat(toDisplayPromoEndDate[1], "/").concat(toDisplayPromoEndDate[2], "/").concat(toDisplayPromoEndDate[0]),
        })
        : "";
};
var LoanBodySection = function (_a) {
    var autopayModalContainerId = _a.autopayModalContainerId, isAutoPayOn = _a.isAutoPayOn, _b = _a.isViewAccountDisabled, isViewAccountDisabled = _b === void 0 ? false : _b, handleMAPClick = _a.handleMAPClick, data = _a.data, conditions = _a.conditions, altText = _a.altText, _c = _a.isIntroRateLoan, isIntroRateLoan = _c === void 0 ? false : _c, featureFlags = _a.featureFlags, showAutopay = _a.showAutopay;
    var loanAmount = data.loanAmount, creditBalance = data.creditBalance, paymentDate = data.paymentDate, isPN4 = data.isPN4, cardArtURL = data.cardArtURL, unformattedCurrentBalance = data.unformattedCurrentBalance, minimumPaymentDue = data.minimumPaymentDue, isInstallmentLoanMonthly = data.isInstallmentLoanMonthly, promoEndDate = data.promoEndDate, isSetpay = data.isSetpay;
    var isPayLater = isPN4 || isInstallmentLoanMonthly;
    var fieldValueNextamountOrTotalAmount = isPayLater || isSetpay ? "nextAmountDue" : "totalAmountDue";
    var unformattedMinimumPaymentDue = minimumPaymentDue.replace("$", "");
    var isPreDelivery = shouldShowPreDeliveryMessage(conditions, featureFlags);
    var isPredeliveryAmountUnavailable = isPreDelivery && Number(unformattedMinimumPaymentDue) === 0;
    var creditBalanceForPreDelivery = isPreDelivery && Number(unformattedCurrentBalance) <= 0
        ? i18n({
            labels: "unavailable",
        })
        : creditBalance;
    return (_jsxs(_Fragment, { children: [_jsxs(Grid, __assign({ container: true, item: true, alignItems: "flex-start" }, { children: [_jsx(Grid, __assign({ item: true, xs: 7 }, { children: _jsx(AccountImage, { src: cardArtURL, alt: altText }) })), _jsxs(Grid, __assign({ container: true, direction: "column", item: true, xs: 5 }, { children: [_jsx(CustomGridVertical, __assign({ item: true, xs: 12 }, { children: _jsx(AccountDetail, { dataCy: "section-1", detail: {
                                        type: isPayLater ? "amountFinanced" : "loanAmount",
                                        value: loanAmount,
                                        toolTipText: isIntroRateLoan
                                            ? i18n({
                                                labels: "introRateLoanTooltip",
                                            })
                                            : tooltipTextSectionOne(isInstallmentLoanMonthly, promoEndDate),
                                    } }) })), _jsx(CustomGridVertical, __assign({ item: true, xs: 12 }, { children: _jsx(AccountDetail, { dataCy: "section-2", detail: {
                                        type: isPayLater || isSetpay
                                            ? "totalLoanBalance"
                                            : "totalRemaining",
                                        value: creditBalanceForPreDelivery,
                                        toolTipText: isPayLater || isSetpay
                                            ? i18n({
                                                labels: "totalLoanBalanceTooltip",
                                            })
                                            : "",
                                    } }) }))] }))] })), _jsxs(Grid, __assign({ item: true, xs: 12, container: true }, { children: [_jsxs(Grid, __assign({ item: true, xs: 7 }, { children: [_jsx(AccountDetail, { dataCy: "section-3", tooltipWrapperClassName: "sm-nowrap", detail: {
                                    type: fieldValueNextamountOrTotalAmount,
                                    value: isPredeliveryAmountUnavailable
                                        ? /* istanbul ignore next */
                                            i18n({
                                                labels: "unavailable",
                                            })
                                        : minimumPaymentDue,
                                    toolTipText: nextAmountTooltip(isIntroRateLoan, isPN4, isInstallmentLoanMonthly, isSetpay),
                                } }), showAutopay && (_jsx("div", __assign({ id: autopayModalContainerId }, { children: _jsx(AutopayButton, { autopayEnrollment: isAutoPayOn, isViewAccountDisabled: isViewAccountDisabled, 
                                    // Since Loans dont't use Autopay deep link we use trigger the MAP callback
                                    handleAutopayClick: handleMAPClick }) })))] })), _jsx(Grid, __assign({ item: true, xs: 5 }, { children: _jsx(AccountDetail, { dataCy: "section-4", detail: {
                                type: "paymentDueDate",
                                value: isPredeliveryAmountUnavailable
                                    ? /* istanbul ignore next */
                                        i18n({
                                            labels: "unavailable",
                                        })
                                    : paymentDate,
                            } }) }))] }))] }));
};
export default LoanBodySection;
//# sourceMappingURL=LoanBodySection.js.map